var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHooked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_62193",
    "data-name": "Group 62193",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 29.907,
    viewBox: "0 0 43 29.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22159",
    "data-name": "Rectangle 22159",
    width: 43,
    height: 29.907,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_107480",
    "data-name": "Path 107480",
    d: "M4.137,105.442v2.525H1.883v-2.525H0v6.345H1.883v-2.362H4.137v2.362H6.019v-6.345Z",
    transform: "translate(0 -81.961)",
    fill: "#1228f3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62192",
    "data-name": "Group 62192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62191",
    "data-name": "Group 62191",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107481",
    "data-name": "Path 107481",
    d: "M38.734,108.42a3.273,3.273,0,0,1-3.458,3.258,3.247,3.247,0,1,1,0-6.481,3.25,3.25,0,0,1,3.458,3.222m-4.987.009A1.614,1.614,0,0,0,35.3,110.1a1.572,1.572,0,0,0,1.5-1.674,1.556,1.556,0,0,0-1.5-1.656,1.593,1.593,0,0,0-1.557,1.656",
    transform: "translate(-24.733 -81.772)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107482",
    "data-name": "Path 107482",
    d: "M72.707,108.42a3.466,3.466,0,1,1-3.458-3.222,3.273,3.273,0,0,1,3.458,3.222m-4.987.009a1.614,1.614,0,0,0,1.557,1.674,1.572,1.572,0,0,0,1.5-1.674,1.556,1.556,0,0,0-1.5-1.656,1.593,1.593,0,0,0-1.557,1.656",
    transform: "translate(-51.141 -81.772)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107483",
    "data-name": "Path 107483",
    d: "M105.707,111.786l-1.475-2.317-.715.8v1.521h-1.883v-6.345h1.883v2.444l2.127-2.444h2.172l-2.3,2.58,2.444,3.765Z",
    transform: "translate(-79.002 -81.96)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107484",
    "data-name": "Path 107484",
    d: "M139.371,105.441v1.448h-3.3v1h3v1.448h-3v1h3.394v1.448h-5.277v-6.345Z",
    transform: "translate(-104.303 -81.961)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107485",
    "data-name": "Path 107485",
    d: "M169.756,108.609a3.147,3.147,0,0,1-3.476,3.177h-2.715v-6.345h2.779a3.106,3.106,0,0,1,3.412,3.168m-1.919.018a1.538,1.538,0,0,0-1.53-1.7h-.86v3.385h.95a1.488,1.488,0,0,0,1.439-1.683",
    transform: "translate(-127.141 -81.961)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107486",
    "data-name": "Path 107486",
    d: "M6.509,15.658a11.8,11.8,0,0,0,3.225.868A7.257,7.257,0,0,1,7.76,15.262,6.538,6.538,0,0,1,5.742,8.293,7.013,7.013,0,0,1,11.355,3.58a8.089,8.089,0,0,1,4.817.832c.114.062.222.138.332.208L14.058,6.007c-.129.1-.032.256.138.231a43.307,43.307,0,0,0,7.1-1.532c.088-.029.125-.071.13-.113.005-.012.015-.021.017-.034a.481.481,0,0,0-.121-.388A11.859,11.859,0,0,0,9.765.324,10.675,10.675,0,0,0,2.342,7.2c-.631,1.882-.776,4.366.624,5.985a11.018,11.018,0,0,0,3.542,2.47",
    transform: "translate(-1.462 -0.002)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107487",
    "data-name": "Path 107487",
    d: "M17.843,15.548a8.385,8.385,0,0,1-5.1,1.556,12.605,12.605,0,0,1-5.041-1.013,11.447,11.447,0,0,1-4.042-2.944,10.487,10.487,0,0,0,3.071,4.7,10.24,10.24,0,0,0,10.905,1.887,14.361,14.361,0,0,0,5.334-4.287c1.574-1.927,2.929-4.013,4.358-6.046,1.59-2.263,3.352-4.554,6.05-5.51a11.385,11.385,0,0,1,8.054.565A11.447,11.447,0,0,1,45.48,7.4a10.486,10.486,0,0,0-3.071-4.7A10.24,10.24,0,0,0,31.5.813,14.2,14.2,0,0,0,26.294,4.95c-1.688,2.024-3.078,4.268-4.641,6.385a21.391,21.391,0,0,1-3.382,3.879q-.211.176-.429.334",
    transform: "translate(-2.848 0)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107488",
    "data-name": "Path 107488",
    d: "M123.795,21.461a8.879,8.879,0,0,0-3.487-2.512,11.806,11.806,0,0,0-3.226-.868,7.257,7.257,0,0,1,1.974,1.264,6.538,6.538,0,0,1,2.019,6.969,7.014,7.014,0,0,1-5.614,4.713,8.091,8.091,0,0,1-4.817-.832c-.114-.062-.222-.138-.332-.208l2.447-1.387c.129-.1.032-.256-.138-.231a43.293,43.293,0,0,0-7.1,1.533c-.088.028-.125.07-.13.113-.005.012-.015.021-.017.034a.483.483,0,0,0,.122.388,13.247,13.247,0,0,0,3.407,2.822,11.146,11.146,0,0,0,12.15-1,10.384,10.384,0,0,0,3.774-6.481,5.4,5.4,0,0,0-1.034-4.312",
    transform: "translate(-81.907 -14.055)",
    fill: "#1228f3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHooked);
export default __webpack_public_path__ + "static/media/hooked.667fdf7ca1e8f14502490870c9701227.svg";
export { ForwardRef as ReactComponent };